/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type LinkContainer_viewer$ref: FragmentReference;
export type LinkContainer_viewer = {|
  +id: string,
  +embed_token: ?string,
  +s_recaptcha_enabled: ?boolean,
  +s_recaptcha_site_key: ?string,
  +s_recaptcha_secret_key: ?string,
  +phones: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +number: ?string,
        +verified: ?boolean,
      |}
    |}>
  |},
  +s_text_on_embed_submit: ?boolean,
  +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref,
  +$refType: LinkContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "LinkContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "embed_token",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_recaptcha_enabled",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_recaptcha_site_key",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_recaptcha_secret_key",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "phones",
      "storageKey": null,
      "args": null,
      "concreteType": "PhoneConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PhoneEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Phone",
              "plural": false,
              "selections": [
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "number",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "verified",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_text_on_embed_submit",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AvailabilityCheckerContainer_viewer",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cb4382d8068f7cb2ca4b8ad80902eb71';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Leads/__generated__/LinkContainer_viewer.graphql.js